import {css} from "lit-element/lit-element.js";
export default css`:host([sm="1"]) {
  grid-column: span 1;
}

:host([sm="2"]) {
  grid-column: span 2;
}

@media screen and (min-width: 768px) {
  :host([md="1"]) {
    grid-column: span 1;
  }
  :host([md="2"]) {
    grid-column: span 2;
  }
  :host([md="3"]) {
    grid-column: span 3;
  }
  :host([md="4"]) {
    grid-column: span 4;
  }
  :host([md="5"]) {
    grid-column: span 5;
  }
  :host([md="6"]) {
    grid-column: span 6;
  }
}
@media screen and (min-width: 992px) {
  :host([lg="1"]) {
    grid-column: span 1;
  }
  :host([lg="2"]) {
    grid-column: span 2;
  }
  :host([lg="3"]) {
    grid-column: span 3;
  }
  :host([lg="4"]) {
    grid-column: span 4;
  }
  :host([lg="5"]) {
    grid-column: span 5;
  }
  :host([lg="6"]) {
    grid-column: span 6;
  }
  :host([lg="7"]) {
    grid-column: span 7;
  }
  :host([lg="8"]) {
    grid-column: span 8;
  }
  :host([lg="9"]) {
    grid-column: span 9;
  }
  :host([lg="10"]) {
    grid-column: span 10;
  }
  :host([lg="11"]) {
    grid-column: span 11;
  }
  :host([lg="12"]) {
    grid-column: span 12;
  }
}
@media screen and (min-width: 1200px) {
  :host([xl="1"]) {
    grid-column: span 1;
  }
  :host([xl="2"]) {
    grid-column: span 2;
  }
  :host([xl="3"]) {
    grid-column: span 3;
  }
  :host([xl="4"]) {
    grid-column: span 4;
  }
  :host([xl="5"]) {
    grid-column: span 5;
  }
  :host([xl="6"]) {
    grid-column: span 6;
  }
  :host([xl="7"]) {
    grid-column: span 7;
  }
  :host([xl="8"]) {
    grid-column: span 8;
  }
  :host([xl="9"]) {
    grid-column: span 9;
  }
  :host([xl="10"]) {
    grid-column: span 10;
  }
  :host([xl="11"]) {
    grid-column: span 11;
  }
  :host([xl="12"]) {
    grid-column: span 12;
  }
}
@media screen and (min-width: 1400px) {
  :host([xxl="1"]) {
    grid-column: span 1;
  }
  :host([xxl="2"]) {
    grid-column: span 2;
  }
  :host([xxl="3"]) {
    grid-column: span 3;
  }
  :host([xxl="4"]) {
    grid-column: span 4;
  }
  :host([xxl="5"]) {
    grid-column: span 5;
  }
  :host([xxl="6"]) {
    grid-column: span 6;
  }
  :host([xxl="7"]) {
    grid-column: span 7;
  }
  :host([xxl="8"]) {
    grid-column: span 8;
  }
  :host([xxl="9"]) {
    grid-column: span 9;
  }
  :host([xxl="10"]) {
    grid-column: span 10;
  }
  :host([xxl="11"]) {
    grid-column: span 11;
  }
  :host([xxl="12"]) {
    grid-column: span 12;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
